// @flow

import { ReactComponent as burger } from "../../assets/icons/burger.svg";
import { ReactComponent as user } from "../../assets/icons/user.svg";
import { ReactComponent as user_login } from "../../assets/icons/user-login.svg";
import { ReactComponent as search } from "../../assets/icons/search.svg";
import { ReactComponent as cart } from "../../assets/icons/cart.svg";
import { ReactComponent as calendar } from "../../assets/icons/calendar.svg";
import { ReactComponent as option } from "../../assets/icons/option.svg";
import { ReactComponent as youtube } from "../../assets/icons/youtube.svg";
import { ReactComponent as facebook } from "../../assets/icons/facebook.svg";
import { ReactComponent as tiktok } from "../../assets/icons/tiktok.svg";
import { ReactComponent as instagram } from "../../assets/icons/instagram.svg";
import { ReactComponent as linkedin } from "../../assets/icons/linkedin.svg";
import { ReactComponent as twitter } from "../../assets/icons/twitter.svg";
import { ReactComponent as discord } from "../../assets/icons/discord.svg";
import { ReactComponent as snapchat } from "../../assets/icons/snapchat.svg";
import { ReactComponent as external_link } from "../../assets/icons/external-link.svg";
import { ReactComponent as ticket_external_link } from "../../assets/icons/ticket-external-link.svg";
import { ReactComponent as link } from "../../assets/icons/link.svg";
import { ReactComponent as arrow_up } from "../../assets/icons/arrow-up.svg";
import { ReactComponent as arrow_down } from "../../assets/icons/arrow-down.svg";
import { ReactComponent as arrow_left } from "../../assets/icons/arrow-left.svg";
import { ReactComponent as arrow_right } from "../../assets/icons/arrow-right.svg";
import { ReactComponent as stem_arrow_left } from "../../assets/icons/stem-arrow-left.svg";
import { ReactComponent as stem_arrow_right } from "../../assets/icons/stem-arrow-right.svg";
import { ReactComponent as chevron_up } from "../../assets/icons/chevron-up.svg";
import { ReactComponent as chevron_down } from "../../assets/icons/chevron-down.svg";
import { ReactComponent as chevron_left } from "../../assets/icons/chevron-left.svg";
import { ReactComponent as chevron_right } from "../../assets/icons/chevron-right.svg";
import { ReactComponent as expand } from "../../assets/icons/expand.svg";
import { ReactComponent as play } from "../../assets/icons/play.svg";
import { ReactComponent as close } from "../../assets/icons/close.svg";
import { ReactComponent as plus } from "../../assets/icons/plus.svg";
import { ReactComponent as plus_circle } from "../../assets/icons/plus-circle.svg";
import { ReactComponent as minus } from "../../assets/icons/minus.svg";
import { ReactComponent as email } from "../../assets/icons/email.svg";
import { ReactComponent as globe } from "../../assets/icons/globe.svg";
import { ReactComponent as filter } from "../../assets/icons/filter.svg";
import { ReactComponent as logout } from "../../assets/icons/logout.svg";
import { ReactComponent as tick } from "../../assets/icons/tick.svg";
import { ReactComponent as paypal } from "../../assets/icons/paypal.svg";
import { ReactComponent as lock } from "../../assets/icons/lock.svg";
import { ReactComponent as truck } from "../../assets/icons/truck.svg";
import { ReactComponent as help } from "../../assets/icons/help.svg";
import { ReactComponent as qr } from "../../assets/icons/qr.svg";
import { ReactComponent as exclamation } from "../../assets/icons/exclamation.svg";
import { ReactComponent as edit } from "../../assets/icons/edit.svg";
import { ReactComponent as download } from "../../assets/icons/download.svg";
import { ReactComponent as page } from "../../assets/icons/page.svg";
import { ReactComponent as vertical_ellipsis } from "../../assets/icons/vertical-ellipsis.svg";
import { ReactComponent as ellipse } from "../../assets/icons/ellipse.svg";

const Icons = {
    burger: burger,
    user: user,
    "user-login": user_login,
    search: search,
    cart: cart,
    calendar: calendar,
    option: option,
    youtube: youtube,
    facebook: facebook,
    tiktok: tiktok,
    instagram: instagram,
    linkedin: linkedin,
    twitter: twitter,
    discord: discord,
    snapchat: snapchat,
    expand: expand,
    play: play,
    plus: plus,
    minus: minus,
    email: email,
    globe: globe,
    "external-link": external_link,
    "ticket-external-link": ticket_external_link,
    "arrow-up": arrow_up,
    "arrow-down": arrow_down,
    "arrow-left": arrow_left,
    "arrow-right": arrow_right,
    "stem-arrow-left": stem_arrow_left,
    "stem-arrow-right": stem_arrow_right,
    "chevron-up": chevron_up,
    "chevron-down": chevron_down,
    "chevron-left": chevron_left,
    "chevron-right": chevron_right,
    "plus-circle": plus_circle,
    close: close,
    filter: filter,
    logout: logout,
    link: link,
    tick: tick,
    paypal: paypal,
    lock: lock,
    truck: truck,
    help: help,
    qr: qr,
    exclamation: exclamation,
    edit: edit,
    page: page,
    download: download,
    "vertical-ellipsis": vertical_ellipsis,
    ellipse: ellipse,
};

export default Icons;
